module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/1/5-e043a60daef912672fba72fd3ef58e0a.jpg";